<mat-accordion [multi]="true">
  @if (filterCategories(); as categories) {
    <form class="search-form" [formGroup]="form" (ngSubmit)="onSearch()">
      <b style="text-transform: uppercase">Search By Style Code</b>
      <mat-form-field>
        <input matInput formControlName="search" data-testid="search-input" />
        <button
          matSuffix
          mat-icon-button
          type="button"
          (click)="clearSearch()"
          aria-label="Clear Filters"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <button type="submit" mat-stroked-button data-testid="search-button">Search</button>
    </form>
    @for (category of categories; track category.attribute) {
      <hr />
      <mat-expansion-panel class="mat-elevation-z0" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ category.displayName }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
          @for (
            option of category.options;
            track option.value;
            let iOption = $index
          ) {
            <div class="checkbox-container">
              @if (option.control) {
                <mat-checkbox
                  #elementRef
                  [formControl]="option.control"
                  [ngClass]="
                    category.attribute === 'colorFamily'
                      ? setColorClass(option.value, elementRef)
                      : ''
                  "
                  >{{ option.value }}</mat-checkbox
                >
              }
            </div>
          }
        </ng-template>
      </mat-expansion-panel>
    }
  }
</mat-accordion>
